module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-code-fill-c901dc07.svg";